import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch,withRouter} from 'react-router-dom';
import * as router from 'react-router-dom';
import { AppConsumer } from '../../Context.js';
import permissionsMap from '../../configs/permissionsMap'

import {
  // AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigations from '../../_nav';
// routes config
import routes from '../../routes';

// const DefaultAside = React.lazy(() => import('./DefaultAside'));
const DefaultFooter = React.lazy(() => import('./DefaultFooter'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));

class DefaultLayout extends Component {

  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

  signOut(e) {
    e.preventDefault();
    sessionStorage.setItem('loggedIn', false);
    this.props.history.push('/login');
    sessionStorage.clear();
  }

  componentDidMount(){
    if(sessionStorage.getItem('loggedIn')==='true'){
       console.log("user logged in");
    }else{
       this.props.history.replace('/login');
    }
  }

  filterNavigations(navigations,permissions){
   const filterNavItems =  navigations.items.filter(nav=>permissions.includes(nav.permission))
    return {items: filterNavItems};
  }

  render() {

    
  function renderDefaultRoute(allowedPermissions){
    if(allowedPermissions.includes(permissionsMap.botsListing)){
      return <Redirect from="/" to="/bots" />
    } else if(allowedPermissions.includes(permissionsMap.conversations)){
      return <Redirect from="/" to="/conversations" />
    } else if(allowedPermissions.includes(permissionsMap.addFaq)){
      return <Redirect from="/" to="/add-faq" />
    } else if(allowedPermissions.includes(permissionsMap.trainBot)){
      return <Redirect from="/" to="/train-bot" />
    }
  }


    return (
      <AppConsumer>
        {(context)=>
        <div className="app">
          <AppHeader fixed>
            <Suspense  fallback={this.loading()}>
              <DefaultHeader onLogout={e=>this.signOut(e)}/>
            </Suspense>
          </AppHeader>
          <div className="app-body">
            <AppSidebar fixed display="lg">
              <AppSidebarHeader />
              <AppSidebarForm />
              <Suspense>
              <AppSidebarNav navConfig={this.filterNavigations(navigations,context.permissions)} {...this.props} router={router}/>
              </Suspense>
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
            <main className="main">
              <AppBreadcrumb appRoutes={routes} router={router} className="breadcrumb-bar"/>
              {/* <Container fluid> */}
                <Suspense fallback={this.loading()}>
                  <Switch>
                    {routes.map((route, idx) => {
                      if(!context.permissions.includes(route.permission))
                        return null;
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <route.component {...props} />
                          )} />
                      ) : (null);
                    })}

                    {/* checking default page access as per permissions */}
                    {renderDefaultRoute(context.permissions)}
                    

                  </Switch>
                </Suspense>
              {/* </Container> */}
            </main>
            {/* <AppAside fixed>
              <Suspense fallback={this.loading()}>
                <DefaultAside />
              </Suspense>
            </AppAside> */}
          </div>
          <AppFooter>
            <Suspense fallback={this.loading()}>
              <DefaultFooter />
            </Suspense>
          </AppFooter>
        </div>
        }
      </AppConsumer>
    );
  }
}

export default withRouter(DefaultLayout);
